import React, { forwardRef } from "react";
import { Bar } from "react-chartjs-2";
import "chartjs-plugin-annotation";
import "chartjs-plugin-zoom";
import _ from "lodash";
import { TYPE_SORT } from "./constants";

const MonoBar = forwardRef(({ data, globalData = {}, typeSort = TYPE_SORT.ALPHABETICALLY }, ref) => {
  data.labels.forEach((label, index) => {
    data.labels[index] = label.replace("@", " ");
  });
  // const dataProcessed = processLabel(data, labels);
  const valueStr = globalData.valueStr || "";
  const kpiLabel = globalData.kpiLabel || "";

  const annotationsOptions =
    valueStr.includes("%") || kpiLabel.includes("MOYEN")
      ? {
          annotations: [
            {
              type: "line",
              mode: "horizontal",
              scaleID: "y-axis-0",
              value: globalData.value,
              borderColor: "#E46902",
              borderWidth: 2,
              borderDash: [2, 2],
              label: {
                backgroundColor: "rgba(0,0,0,0.3)",
                position:
                  typeSort === TYPE_SORT.INCREASING ? "left" : typeSort === TYPE_SORT.DECREASING ? "right" : "center",
                enabled: true,
                content: `${globalData.kpiLabel} = ${valueStr}`
              }
            }
          ]
        }
      : {};

  return (
    // <div id="monobar2">

    <Bar
      ref={ref}
      data={data}
      // width={400}
      // height={100}
      responsive
      // plugins={[
      //   {
      //     beforeUpdate: function(chart) {
      //       chart.data.labels.forEach(function(e, i, a) {
      //         if (e && e.split) {
      //           let aiValues = e.split(" ");
      //           //console.log(aiValues);
      //           for (let j = 0; j < aiValues.length; j++) {
      //             let aiValue = aiValues[j];
      //             if (typeof aiValue === "string") {
      //               aiValue = aiValue.replace("@", " ");
      //               aiValues[j] = aiValue;
      //             }
      //           }
      //           a[i] = aiValues;
      //         }
      //       });
      //     }
      //   }
      // ]}
      options={{
        annotation: annotationsOptions,

        plugins: {
          zoom: {
            pan: {
              enabled: true,
              mode: "x",
              // speed: 10,
              // threshold: 10,
              onPan: function({ chart }) {},
              // Function called once panning is completed
              onPanComplete: function({ chart }) {}
            },
            zoom: {
              enabled: true,
              mode: "x",
              // drag: true,
              // speed: 0.1,
              // drag: {
              //   borderColor: "rgba(225,0,225,0.3)",
              //   borderWidth: 10,
              //   backgroundColor: "rgb(0,225,225)",
              //   animationDuration: 30
              // },
              // Minimal zoom distance required before actually applying zoom
              // threshold: 2,

              // On category scale, minimal zoom level before actually applying zoom
              // sensitivity: 3,
              onZoom: function({ chart }) {},
              // Function called once zooming is completed
              onZoomComplete: function({ chart }) {
                // console.log(`I was zoomed!!!`, chart.boxes[2].ticks);
              }
            }
          },
          datalabels: {
            textAlign: "center",
            anchor: "end",
            align: "top",
            offset: -5
          }
        },
        animation: {
          duration: 3000 // general animation time
        },
        maintainAspectRatio: false,
        scales: {
          xAxes: [
            {
              gridLines: {
                offsetGridLines: false,
                display: false
              },
              scaleLabel: {
                fontSize: 5,
                fontColor: "#2e22aa"
              },
              ticks: {
                autoSkip: true,
                maxRotation: 0,
                minRotation: 0,
                fontSize: 9,

                callback: function(value, index, values) {
                  return value;
                }
              }
            }
          ],
          yAxes: [
            {
              scaleLabel: {
                display: true
              },
              ticks: {
                scaleBeginAtZero: true
              }
            }
          ]
        }
      }}
      legend={{ display: false }}
    />
    // </div>
  );
});

export default MonoBar;



// WEBPACK FOOTER //
// src/modules/stats/containers/summary/Global/MonoBar.js